import {IMAGES} from '../../../constants/assetLists';

type Props = {
  clientLogo?: string;
};

function PublicFormHeader({clientLogo}: Props) {
  return (
    <div className="w-full h-[56px] bg-darkBlue flex justify-between items-center flex-shrink-0">
      {/* Client Logo */}
      <div className="w-[128px] h-[56px] bg-white flex justify-center items-center">
        <img
          src={clientLogo || IMAGES.placeholder}
          alt="client"
          className="w-[72px] h-[44px] object-fill"
        />
      </div>

      {/* Cheq-Qit Logo */}
      <div className="w-[140px] h-[24px] me-5">
        <img
          src={IMAGES.logo}
          alt="Cheq-Qit"
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );
}

export default PublicFormHeader;
